var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgSettingsThreeKnobs = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 20,
  height: 18,
  viewBox: "0 0 20 18",
  role: "img"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#FF3CA0",
  fillRule: "evenodd",
  d: "M6 12c1.302 0 2.401.839 2.815 2H19a1 1 0 1 1 0 2H8.815A2.995 2.995 0 0 1 6 18a2.995 2.995 0 0 1-2.815-2H1a1 1 0 1 1 0-2h2.185A2.995 2.995 0 0 1 6 12m0 2a1 1 0 1 0 0 2 1 1 0 0 0 0-2m8-8c1.302 0 2.401.839 2.815 2H19a1 1 0 1 1 0 2h-2.185A2.995 2.995 0 0 1 14 12a2.995 2.995 0 0 1-2.815-2H1a1 1 0 1 1 0-2h10.185A2.995 2.995 0 0 1 14 6m0 2a1 1 0 1 0 0 2 1 1 0 0 0 0-2M6 0c1.302 0 2.401.839 2.815 2H19a1 1 0 1 1 0 2H8.815A2.995 2.995 0 0 1 6 6a2.995 2.995 0 0 1-2.815-2H1a1 1 0 1 1 0-2h2.185A2.995 2.995 0 0 1 6 0m0 2a1 1 0 1 0 0 2 1 1 0 0 0 0-2"
})));
export default SvgSettingsThreeKnobs;